import React from 'react';
import classNames from 'classnames';
import { FieldTextInput, FieldCheckbox, InfoTipForFields } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';


import BulletPointsField from '../../components/BulletPointsField/BulletPointsField';
import css from './EditListingDescriptionForm.module.css';

const SubcategoryOption = props => {
  const { values, item, clearOtherSubcategoryValues } = props;

  const isSelected = values.subcategory?.filter(option => option === item.key)?.length;

  return (
    <div
      key={item.key}
      className={classNames(css.subCategoryItem, {
        [css.subCategoryItemSelected]: !!isSelected,
      })}
    >
      <div
        onClick={() => {
          item.key.includes('Other') && clearOtherSubcategoryValues(`${item.key}Description`);
        }}
      >
        <FieldCheckbox
          key={item.key}
          id={item.key}
          name={'subcategory'}
          label={item.label}
          value={item.key}
          radio={false}
        />
      </div>
    </div>
  );
};

const EditListingSubcategoryField = props => {
  const { values, subCategoryOptions, categoryOptions, clearOtherSubcategoryValues } = props;

  const subcategoryField = values?.category && Array.isArray(values?.category);

  const subCategoryFilteredOptions =
    subCategoryOptions?.filter(s => values?.category?.includes(s?.category))?.length > 0;


  return (
    <>
      {subcategoryField && subCategoryFilteredOptions && (
        <div className={css.subCategoryHolder}>
          <label htmlFor="">
            <span className={css.isRequired}>Subcategory</span>
            <InfoTipForFields tipId={'EditListingDescriptionForm.categoryTip'} />
          </label>
          {values.category.map(item => {
            const categoryTitle = categoryOptions.filter(cat => cat.key === item)?.[0]?.label;

            const isOtherSelected = values?.subcategory?.filter(option => option === `${item}Other`)?.length;

            const otherFieldValue = !!isOtherSelected && values[`${item}OtherDescription`];
            const isOtherFieldValueNotEmpty = !!otherFieldValue && !!otherFieldValue.length
            const validationError = !isOtherFieldValueNotEmpty

            if(item === "investigation") return null
            
            return (
              <>
                <div className={css.subCategoryHolder}>
                  <label className={css.subCategoryTitle}>Category: {categoryTitle}</label>
                  {subCategoryOptions
                    .filter(s => s.category === item)
                    .map((item, i) => {
                      return (
                        <SubcategoryOption
                          item={item}
                          values={values}
                          clearOtherSubcategoryValues={clearOtherSubcategoryValues}
                        />
                      );
                    })}
                </div>
                {!!isOtherSelected && (
                  // <FieldTextInput
                  //   key={`${item}OtherDescription`}
                  //   id={`${item}OtherDescription`}
                  //   name={`${item}OtherDescription`}
                  //   type="text"
                  //   placeholder={'Type here...'}
                  // />
                  <>
                    <BulletPointsField
                      key={`${item}OtherDescription`}
                      id={`${item}OtherDescription`}
                      name={`${item}OtherDescription`}
                      isRequired={!isOtherFieldValueNotEmpty}
                    />
                    {validationError && (
                        <p className={css.error}>
                          <FormattedMessage id="ReviewForm.reviewOtherDescriptionRequired" />
                        </p>
                      )}
                  </>
                )}
              </>
            );
          })}
        </div>
        // <FieldCheckboxGroup
        //   label={'Subcategory'}
        //   className={css.checkboxesField}
        //   id={'subcategory'}
        //   name={'subcategory'}
        //   options={subategoryOptions.filter(s => s.category === values.category)}
        //   radio={true}
        //   withPrice
        // />
      )}
    </>
  );
};

export default EditListingSubcategoryField;
